import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { CommonButton } from "../ui/buttons/CommonButton";

import styles from "./styles/legal.module.css";

export const TermsOfUse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromAuthModal = useRef(location.state?.fromAuthModal);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/", { replace: true });
    }
  };

  useLayoutEffect(() => {
    if (location.state?.fromAuthModal) {
      fromAuthModal.current = true;
    }

    return () => {
      if (fromAuthModal.current) {
        sessionStorage.setItem("reopenAuthModal", "true");
      }
    };
  }, [location.state?.fromAuthModal]);

  return (
    <article className={styles.terms}>
      <CommonButton onClick={handleBack} text="Повернутися назад" />

      <h1>Умови користування</h1>

      <section>
        <h2>1. Загальні положення</h2>
        <p>
          Використовуючи цей вебсайт та його освітні матеріали, ви
          підтверджуєте, що ознайомилися з цими Умовами користування та
          погоджуєтеся з ними. Якщо ви не погоджуєтеся з будь-якою частиною умов
          – припиніть користування сайтом.
        </p>
      </section>

      <section>
        <h2>2. Використання сайту</h2>
        <p>
          Ви зобов&apos;язуєтеся використовувати сайт виключно в законних цілях
          і не здійснювати дій, які можуть порушити його роботу, безпеку або
          завдати шкоди іншим користувачам. Забороняється спроба
          несанкціонованого доступу до систем, акаунтів інших користувачів або
          будь-яких серверів.
        </p>
      </section>

      <section>
        <h2>3. Акаунти користувачів</h2>
        <p>
          Для доступу до курсів може знадобитися реєстрація та створення
          акаунта. Ви несете відповідальність за збереження конфіденційності
          вашого облікового запису. Усі дії, виконані через ваш акаунт,
          вважаються вашими. Ми залишаємо за собою право призупиняти або
          видаляти акаунти у разі порушення умов користування.
        </p>
      </section>

      <section>
        <h2>4. Контент</h2>
        <p>
          Увесь навчальний контент на сайті надається «як є». Ми не гарантуємо
          його повноту, точність або актуальність та залишаємо за собою право
          змінювати або видаляти будь-які матеріали без попереднього
          повідомлення.
        </p>
      </section>

      <section>
        <h2>6. Поведінка на платформі</h2>
        <p>
          Користувачі зобов&apos;язані дотримуватися етичних норм, не
          розповсюджувати образливий, дискримінаційний або незаконний контент у
          коментарях, форумах чи чатах. Порушення може призвести до блокування
          акаунту.
        </p>
      </section>

      <section>
        <h2>7. Відповідальність</h2>
        <p>
          Ми не несемо відповідальності за будь-які прямі або непрямі збитки, що
          виникли внаслідок використання або неможливості використання сайту або
          його матеріалів.
        </p>
      </section>

      <section>
        <h2>8. Посилання на сторонні ресурси</h2>
        <p>
          Сайт може містити посилання на сторонні ресурси. Ми не контролюємо їх
          зміст і не несемо відповідальності за їхню політику або дії.
        </p>
      </section>

      <section>
        <h2>9. Зміни умов</h2>
        <p>
          Ми залишаємо за собою право змінювати ці Умови користування у
          будь-який час. Актуальна версія завжди доступна на цій сторінці.
        </p>
      </section>

      <section>
        <h2>10. Контактна інформація</h2>
        <p>
          Якщо у вас є запитання щодо цих Умов користування або пропозиції щодо
          курсу, ви можете зв&apos;язатися з нами через доступні на сайті канали
          звʼязку.
        </p>
      </section>

      <CommonButton onClick={handleBack} text="Повернутися назад" />
    </article>
  );
};
